<template>
    <div class="lineItem" v-infinite-scroll="loadMore" infinite-scroll-disabled='loading' infinite-scroll-distance='10'>
        <div class="lineItem_list" v-for='(item, index) in orderData' :key="index" @click="goOrderDetail(item)">
            <div class="lineItem_head">
                <div>
                    <span style="font-size: .4rem">订单号：{{ item.id}}</span>
                    <span style="font-size: .35rem">点餐时间：{{ item.created_at}}</span>
                </div>
                <div>
                    <span class="site_text">{{ item.product.name }}</span>
                    <span class="status_text">{{ item.order_info }}</span>
                </div>
                <div>
                    <span class="site_text" style="color: red">￥{{ item.product.price }}</span>
                    <span style="font-size: .35rem">领餐时间：{{ item.used_at}}</span>
                </div>
            </div>
        </div>
        <!--显示加载中-->
        <div class="loading-box" v-if="isloading">
            <mt-spinner type="snake" class="loading-more"></mt-spinner>
            <span class="loading-more-txt">加载中...</span>
        </div>
        <!-- 显示没有更多 -->
        <div class="no-more" v-show="noMone">暂无更多数据</div>
    </div>
</template>

<script>
    import common from "../common";
    import {InfiniteScroll, Spinner} from 'mint-ui';
    import Vue from "vue";
    import { Dialog } from 'vant';

    Vue.use(InfiniteScroll);
    Vue.component(Spinner.name, Spinner);
    Vue.use(Dialog);
    export default {
        name: 'orderList',
        data() {
            return {
                msg: '订单列表',
                orderData: [],
                pageVal: "0",
                pageSize: "10",
                loading: false, //为true时不会触发加载更多，false可以触发
                isloading: false,//显示加载中
                noMone: false,//是否没有更多
                token: "",
                show: false,
            }
        },
        methods: {
            //获取列表
            getList() {
                let token = this.token;
                let querystring = require('querystring');
                this.$api.post('wx/service/orderList',
                    querystring.stringify({
                        pageSize: this.pageSize,
                        pageNum: this.pageVal,
                        token: token
                    })
                ).then(data => {
                    this.orderData = data.data.data;
                    if (this.pageVal < data.data.pageTotal) {
                        for (var i = 0; i < this.pageSize; i++) {
                            this.orderData.push(data.data.data[i]);
                        }
                        this.loading = false;
                    } else if (this.pageVal == data.data.pageTotal) {
                        for (var i = 0; i < data.data.data.length; i++) {
                            this.orderData.push(data.data.data[i]);
                        }
                        this.loading = false;
                    } else {
                        this.loading = true;
                        this.noMone = true;
                    }
                    this.isloading = false;
                }).catch(err => {
                    console.log(err);
                })
            },
            //分页加载更多
            loadMore() {
                this.loading = true;
                this.isloading = true;
                this.pageVal++;
                this.getList();
            },
            goOrderDetail(item) {
                let querystring = require("querystring");
                let token = this.token;
                this.$api.post("wx/service/orderUsed",
                    querystring.stringify({
                        token: token,
                        order_id: item.id
                    })
                ).then(({data}) => {
                    if (data.status == 1) {
                        Dialog.alert({
                            title: '点餐详情',
                            message: '<p>' + item.id + '</p><p>' + item.product.name + '</p>' + '<p style="color:red;font-siez:.5rem;">￥' + item.product.price + '</p>' + '<p>'+data.data.qrcode+'</p>',
                        }).then(() => {
                            // on close
                        });
                    } else {

                    }
                });
            }
        },
        mounted() {
            //判断cookie中是否存在token
            let ifcookietoken = document.cookie.indexOf("token=") != -1;
            if (!!JSON.parse(common.getlocalStorage("userInfo"))) {
                this.token = JSON.parse(common.getlocalStorage("userInfo")).token;
            } else if (ifcookietoken) {
                this.token = common.getCookie("token");
            } else {
                this.$router.replace({name: 'login'});
            }
        },
        beforeDestroy() {

        },
    }
</script>

<style scoped>
    .lineItem {
        width: 100vw;
        height: 100vh;
        background: #f5f5f5;
        overflow: scroll;
        color: #666666;
        font-size: .4rem;
    }

    .lineItem_list {
        width: 100vw;
        height: 20vh;
        background: white;
        margin-bottom: 1vh;
    }

    .lineItem_list > div {
        width: 90vw;
        margin: 1vh auto;
        padding: 0 2vw;
        display: -webkit-flex;
        flex-direction: column;
    }

    .lineItem_list > .lineItem_head {
        height: 20vh;
        padding: 0 0;
        justify-content: space-around;
    }

    .lineItem_head > div {
        display: -webkit-flex;
        justify-content: space-between;
    }

    .loading-box {
        align-items: center;
        display: -webkit-flex;
        justify-content: center;
    }

    .no-more {
        width: 100VW;
        height: 20vh;
        text-align: center;
        line-height: 80px;
        font-size: 16px;
    }
</style>


// WEBPACK FOOTER //
// src/components/orderList.vue